import React, { Fragment } from 'react';
import { Icon } from '@mui/material';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './sidePanel.scss';

export const SidePanelHeader = (props) => {
    return <div className="side-panel-header" style={{ ...props.style }}>{props.children}</div>;
};

export const SidePanelBody = (props) => {
    return <div className={cx("", props.className ? props.className : "side-panel-body")} style={{ ...props.style }}>{props.children}</div>;
};

export const SidePanelFooter = (props) => {
    return <div className={cx("side-panel-footer", props.className)} style={{ ...props.style }}>{props.children}</div>;
};

const SidePanel = (props) => {
    let icon = props.isOpen ? 'navigate_next' : 'navigate_before';

    const SidePanelbutton = (props) => (
                
        <span
            className={`side-panel-button side-panel-button-${props.direction ? props.direction : 'right'} ${props.sidePanelButtonStyle ? props.sidePanelButtonStyle : ''}`}
            onClick={props.toggle}
        >
            <Icon style={{ fontSize: 28 }}>{icon}</Icon>
        </span>
    )

    return (
        <Fragment>
            <div className={`${(props.overlay && props.isOpen) && "overlay-panel"}`}></div>
            <div
                id='id_sidePanel'
                style={{ ...props.style }}
                className={`side-panel ${props.isOpen ? 'shown-' + (props.direction ? props.direction : 'right') : ''
                    } side-panel-${props.direction ? props.direction : 'right'} ${props.classSidePanel ? props.classSidePanel : ''}`}
            >
                <div
                    className={props.classPanelContent ? props.classPanelContent : "side-panel-content"}
                    style={{ ...props.contentStyle }}
                >
                    {props.children}
                </div>

                {!props?.hiddenButton && (
                    <SidePanelbutton {...props} />
                )}

                {props?.hiddenButton && props.isOpen && (
                    <SidePanelbutton {...props} />
                )}

            </div>
        </Fragment>

    );
};

export default SidePanel;

SidePanel.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};